export type UpdateMode = 'boundary' | 'move';

export const getCursor = (updateMode: UpdateMode | null) =>
  updateMode === 'move'
    ? 'grabbing'
    : updateMode === 'boundary'
    ? 'ew-resize'
    : undefined;
